import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import toast from "react-hot-toast";
import { BiTrash } from "react-icons/bi";

import api from "../../services/api";
import Table from "../../components/Table";

const STATUS = {
  DRAFT: <span className="text-xs text-gray-500">Brouillon</span>,
  PENDING: <span className="text-xs text-yellow-500">En attente</span>,
  ACCEPTED: <span className="text-xs text-green-500">Validée</span>,
  REJECTED: <span className="text-xs text-red-500">Refusée</span>,
};

const HEADER = [
  { title: "ID", key: "_id", debug: true },
  { title: "Company ID", key: "company_id", debug: true },
  { title: "Statut", key: "annonce_status" },
  { title: "Titre de l'annonce", key: "annonce_title" },
  { title: "Entreprise", key: "company_name" },
  { title: "Créer par", key: "user_first_name" },
  { title: "Date de création", key: "created_at" },
  { title: "Actions", key: "actions" },
];

const List = () => {
  const [filters, setFilters] = useState({
    status: "",
    page: 1,
    limit: 50,
    sort: { created_at: -1 },
  });
  const [total, setTotal] = useState(0);
  const [debug, setDebug] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleDelete = async (item) => {
    const confirm = window.confirm("Voulez-vous vraiment supprimer cette entreprise ?");
    if (!confirm) return;
    try {
      const res = await api.delete(`/company/${item._id}`);
      if (!res.ok) throw res;
      toast.success("Entreprise supprimée avec succès");
      setCompanies((prev) => prev.filter((company) => company._id !== item._id));
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la suppression de l'entreprise");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const query = { annonce: true, annonce_type: "cession" };
        if (filters.status) query.annonce_status = filters.status;
        if (filters.sort) query.sort = filters.sort;
        if (filters.page) query.skip = (filters.page - 1) * filters.limit;
        if (filters.limit) query.limit = filters.limit;
        const res = await api.post("/company/search", query);
        if (res.ok) setCompanies(res.data);
        setTotal(res.total);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [filters]);

  return (
    <div className="p-8">
      <header className="w-full">
        <h1 className="text-3xl font-semibold text-black mb-2">Annonces (cession)</h1>
        <p className="text-base text-gray-500">Voici la liste des annonces de cession</p>
      </header>
      <select
        className="select mt-3 block w-fit px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
        value={filters.status}
        onChange={(e) => setFilters((prevFilters) => ({ ...prevFilters, status: e.target.value }))}>
        <option value="">Toutes les annonces</option>
        <option value="DRAFT">Brouillon</option>
        <option value="PENDING">En attente</option>
        <option value="ACCEPTED">Validée</option>
        <option value="REJECTED">Refusée</option>
      </select>

      <label className="flex items-center gap-2 cursor-pointer text-sm mt-3">
        <input type="checkbox" className="checkbox" checked={debug} onChange={(e) => setDebug(e.target.checked)} />
        <span>Mode débug</span>
      </label>

      <section className="w-full py-4 flex flex-col">
        {companies.map((item) => console.log(item))}
        <Table
          sort={filters.sort}
          onSort={(key) => {
            setFilters({ ...filters, sort: { [key]: filters.sort[key] === 1 ? -1 : 1 } });
          }}
          header={HEADER.filter((item) => {
            if (debug) return true;
            return !item.debug;
          })}
          loading={loading}
          noResultRender={<div className="w-full bg-white text-center p-2 my-5 rounded shadow-sm">Aucune résultat n'a été trouvé</div>}>
          {companies.map((item, index) => (
            <tr
              onClick={() => navigate(`/cession/${item._id}`)}
              className="bg-white odd:bg-gray-50 hover:bg-gray-100 h-14 rounded-lg cursor-pointer border hover:border-gray-400"
              key={item._id}>
              {debug && <td>{item._id}</td>}
              {debug && <td>{item.company_id}</td>}
              <td className="p-2 max-w-xs">
                <div>{STATUS[item.annonce_status]}</div>
              </td>
              <td className="p-2 max-w-xs truncate">{item.annonce_title}</td>
              <td className="p-2 max-w-xs truncate">{item.company_name}</td>
              <td className="p-2 max-w-xs truncate">
                {item.user_first_name} {item.user_last_name}
              </td>
              <td className="p-2 max-w-xs truncate">
                {new Date(item.created_at).toLocaleString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })}
              </td>
              <td className="p-2 max-w-xs truncate text-center">
                <button
                  type="button"
                  title="Supprimer l'annonce"
                  className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-100 transition-colors duration-150"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleDelete(item);
                  }}>
                  <BiTrash className="text-red-500 text-lg hover:text-red-700 transition-colors duration-150" />
                </button>
              </td>
            </tr>
          ))}
        </Table>
        <Pagination page={filters.page} setPage={(page) => setFilters({ ...filters, page })} last={Math.ceil(total / filters.limit)} />
      </section>
    </div>
  );
};

export default List;
